import { useGlobalAppState } from '../GlobalAppState/GlobalAppState';

export const useLastInteractedStoreMachine = () => {
  const { lastInteractedStoreMachineRef } = useGlobalAppState();

  return lastInteractedStoreMachineRef;
};
